import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {BehaviorSubject, forkJoin, Observable, of} from 'rxjs';
import {map, tap, filter, concatMap, concatAll, toArray, delay} from 'rxjs/operators';
import {ROUTESURL} from 'src/app/app-routing.model';
import {SpinnerService} from 'src/app/shared/services/spinner/spinner.service';
import {IBankamountData} from '../../components/bankamount/bankamount.model';
import {MergeQuestiondataService} from '../../services/merge-questiondata.service';
import {ISendData} from './consent-declaration.model';
import {BankamountService} from '../../components/bankamount/bankamount.service';
import {StatusService} from 'src/app/shared/services/status/status.service';
import {STATUS} from 'src/app/shared/services/status/status.model';
import {DOCUMENT} from '@angular/common';
import {ConsentDeclarationService} from './consent-declaration.service';
import {ForwardService} from '../../services/forward/forward.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TRANSLATE_PATH as TRANSLATE_PATH_PROJECT } from '../../project.model';
import { TRANSLATE_PATH as TRANSLATE_PATH_SHARED } from 'src/app/shared/shared.model'
import {ERROR, SharedOpenapiCastService} from 'build/project/openapi-cast/shared/shared-openapi-cast.service';
import {IIdentifier} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {IMetaContent} from 'src/app/shared/components/field-item/field-item.model';
import {SuccessDialogComponent} from '../../dialogs/success-dialog/success-dialog.component';


@Component({
   selector: 'app-consent-declaration',
   templateUrl: './consent-declaration.component.html',
   standalone: false
})
export class ConsentDeclarationComponent implements OnInit {

   public TRANSLATE_PATH_PROJECT = TRANSLATE_PATH_PROJECT;
   public TRANSLATE_PATH_SHARED = TRANSLATE_PATH_SHARED; 

   public consentDeclarationForm: FormGroup = this.fb.group({});
   private loaded_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public loaded$: Observable<boolean> = this.loaded_.asObservable();
   public id: IIdentifier = {} as IIdentifier;

   constructor (@Inject(DOCUMENT) public readonly document: Document, public sMergeQuestiondata: MergeQuestiondataService, public sSharedOpenapi: SharedOpenapiCastService, private fb: FormBuilder, private router: Router, public sSpinner: SpinnerService, private dialog: MatDialog, private sBankamount: BankamountService, public sStatus: StatusService, private cdRef: ChangeDetectorRef, private sConsentDeclaration: ConsentDeclarationService, private sForward: ForwardService) {
   }

   get window (): Window {
      return this.document.defaultView!;
   }

   ngOnInit (): void {
      this.sSharedOpenapi.isConnected$.pipe(
         tap(_ => this.loaded_.next(false)),
         filter (value => value == ERROR.CONNECT),
         concatMap(_ => {
            let result: boolean = true;
            sessionStorage.getItem('code') && sessionStorage.getItem('code') != null ? this.id.code = sessionStorage.getItem('code')! : result = false;
            sessionStorage.getItem('birthday') && sessionStorage.getItem('birthday') != null ? this.id.birthday = sessionStorage.getItem('birthday')! : this.id.birthday = "";
            return of(result);
         }),
         concatMap(value => value ? this.initializeFormGroup() : of(value))
      ).subscribe(value => value ? this.loaded_.next(true) : this.router.navigate([ROUTESURL.NOTFOUND]));

      this.sStatus.status$.subscribe(() => this.cdRef.detectChanges());
      
      this.sStatus.status$.pipe(
         filter(value => value == STATUS.SUCCESSREDIRECT),
         delay(this.sStatus.delayTimeRedirect)
      ).subscribe(() => this.window.open(this.sStatus.agreementUrl, this.sStatus.target));
   }

   private initializeFormGroup (): Observable<boolean> {

      this.consentDeclarationForm = this.fb.group({});

      this.consentDeclarationForm.addControl('questionItemList', this.fb.control(''));
      this.consentDeclarationForm.get('questionItemList')?.valueChanges.subscribe();

      this.consentDeclarationForm.addControl('bankamount', this.fb.control(''));
      this.consentDeclarationForm.get('bankamount')?.valueChanges.subscribe();

      this.consentDeclarationForm.addControl('userdata', this.fb.control(''));
      this.consentDeclarationForm.get('userdata')?.valueChanges.subscribe();

      return of(true);
   }

   public validateFormgroup (array: IMetaContent[]):IMetaContent[] {
      this.consentDeclarationForm.updateValueAndValidity();
      return this.consentDeclarationForm.valid ? array : [] as IMetaContent[];
   }
 
   private postData (): Observable<any> {
      const bank: IBankamountData = {
         bankAmountToggle: this.consentDeclarationForm.get("bankamount")?.value,
         shwoBankAmount: this.sBankamount.showComponent ? true : false
      };

      const sendData: ISendData = {
         question: this.consentDeclarationForm.get('questionItemList')?.value as IMetaContent [],
         bankamount: bank
      };

      return this.sMergeQuestiondata.sendData(this.id, this.validateFormgroup(sendData.question).filter(item => item.send)).pipe(map(() => true));
   }

   public onClickSubmit (): void {
      this.sSpinner.start(100);
      this.consentDeclarationForm.updateValueAndValidity();
      if (this.consentDeclarationForm.valid) {
         this.consentDeclarationForm.markAsUntouched();
         this.postData().subscribe((ret) => {
            this.sSpinner.close();
            ret ? this.openDialog() : this.router.navigate([ROUTESURL.MAINTENANCEWORK]);
         });
      }
   }
   
   private openDialog () {
      this.sStatus.status = this.sForward.consent ? STATUS.SUCCESSREDIRECT : STATUS.SUCCESS;
      sessionStorage.clear();
      this.dialog.open(SuccessDialogComponent, {
         autoFocus: true,
         disableClose: true,
         hasBackdrop: true,
         backdropClass: 'backdrop-background-GD'
      });
   }
}
